import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { getIn } from 'formik'
import PropTypes from 'prop-types'

import Checkbox from '../../../../../../components/Form/Checkbox'
import ActionText from '../../../../../../components/ActionText'

import { getMetricPath, getMetricsGroupPath } from '../../helpers'

import useDrawerFormClasses from '../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const MetricsSection = ({ formik, metricsGroupName, title, metrics = [], isCustomMetric }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const drawerFormClasses = useDrawerFormClasses()

  const isAllChecked = useMemo(
    () =>
      metrics.every(metric =>
        getIn(values, getMetricPath({ metricsGroupName, metricValue: metric.value, isCustomMetric }))
      ),
    [metrics, values, metricsGroupName, isCustomMetric]
  )

  const selectOrDeselectAllHandler = useCallback(() => {
    const updatedGroup = metrics.reduce((acc, metric) => {
      acc[metric.value] = !isAllChecked
      return acc
    }, {})

    setFieldValue(getMetricsGroupPath({ metricsGroupName, isCustomMetric }), updatedGroup)
  }, [metrics, setFieldValue, metricsGroupName, isCustomMetric, isAllChecked])

  return (
    <section className={drawerFormClasses.section}>
      <div className={classes.sectionHeader}>
        <h3 className={classes.sectionTitle}>{t(title)}</h3>
        <ActionText className={classes.selectOrDeselectAllButton} onClick={selectOrDeselectAllHandler}>
          {isAllChecked ? t('Deselect all') : t('Select all')}
        </ActionText>
      </div>
      <p>{t('Select which metrics to include on the report')}</p>
      {metrics.map(metric => {
        const metricPath = getMetricPath({ metricsGroupName, metricValue: metric.value, isCustomMetric })
        const checked = getIn(values, metricPath)

        return (
          <Checkbox
            name={metric.value}
            id={metric.value}
            title={metric.label}
            checked={checked}
            onCheck={() => {
              setFieldValue(metricPath, !checked)
            }}
          />
        )
      })}
    </section>
  )
}

MetricsSection.propTypes = {
  formik: PropTypes.object.isRequired,
  metricsGroupName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  metrics: PropTypes.array,
  isCustomMetric: PropTypes.bool
}

export default MetricsSection
